<template>
  <input type="button" class="btn btn-primary form-countdown" :disabled="disabled" :value="text">
</template>

<script>
export default {
  name: 'CountdownButton',
  props: {
    seconds: { type: Number, default: 60 }
  },
  data() {
    return {
      disabled: false,
      time: 0,
      timer: null // 倒计时定时器
    }
  },
  computed: {
    text() {
      return this.time > 0 ? this.time + 's' : '发送'
    }
  },
  methods: {
    startTimer() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.time <= 0) {
          this.disabled = false
          clearInterval(this.timer)
        } else {
          this.disabled = true
        }
        this.time--
      }, 1000)
    },
    start() {
      this.time = this.seconds
      this.disabled = true
      this.startTimer()
    },
    stop() {
      clearInterval(this.timer)
      this.disabled = false
      this.time = 0
    }
  },
  beforeDestroy() {
    clearInterval(this.timer)
  }
}
</script>
